module.exports = __webpack_public_path__ + "img/weddingbox@2x.3dbcdee.jpg";